import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as layoutActions from "../../actions/layoutActions";
import * as ajaxActions from "../../actions/ajaxCounterActions";

import GeneesmiddelOverzichtForm from "./GeneesmiddelOverzichtForm";
import GeneesmiddelFilterForm from "./GeneesmiddelFilterForm";
import Section from "../common/Section";
import redirector from "../../util/redirector";
import GeneesmiddelOverzichtPageHelper from "./GeneesmiddelOverzichtPageHelper";
import ScrollToFirstErrorComponent from "../common/ScrollToFirstErrorComponent";
import { throwException } from "../../actions/exceptionActions";

class GeneesmiddelOverzichtPage extends ScrollToFirstErrorComponent {
    constructor(props, context) {
        super(props, context, false);

        this.filesHelper = null;
        this.state = {
            pagedModels: { items: [] },
            pageSize: 20,
            filterModel: {},
            pageNo: 1,
            tableSortedOnIndex: null,
            geneesmiddelNaamFromFilter: "",
            detailModalOpen: false,
            detailModel: {},
            filterItems: [],
            timeOut: null,
            selectedResult: ""
        };

        this.pageHelper = new GeneesmiddelOverzichtPageHelper(this, redirector);
    }

    componentDidMount = () => {
        super.componentDidMount();
        this.pageHelper.init();
    };

    handleOnPageNoChange = (activePage) => this.pageHelper.onPageNoChange(activePage);
    handleOnPageSizeChange = (pageSize) => this.pageHelper.onPageSizeChange(pageSize);
    handleOnSortTable = (e) => this.pageHelper.onSortTable(e);
    handleOnSearch = (event, pageNo, pageSize, naam, sortAscending) => this.pageHelper.onSearch(event, pageNo, pageSize, naam, sortAscending);
    handleOnChangeFilter = (e) => this.pageHelper.onChangeFilter(e);
    handleOnClickShowDetail = (id, e) => this.pageHelper.onClickShowDetail(id, e);
    handleOnCancelShowDetail = (e) => this.pageHelper.onCancelShowDetail(e);
    handleOnSelectSearchOption = (event, data) => this.pageHelper.onSelectSearchOption(event, data);
    handleOnSearchTextChange = (event, data) => this.pageHelper.onSearchTextChange(event, data);
    handleOnKeyUp = (event) => this.pageHelper.onKeyUpFilter(event);
    handleOnChangeSelectOption = (event, data) => this.pageHelper.onChangeSelectOption(event, data);

    render() {
        const { pagedModels, geneesmiddelNaamFromFilter, filterModel, detailModel, detailModalOpen, filterItems } = this.state;
        const { portaalTeksten } = this.props;

        return (
            <Section classNames="c-section--styles">
            <GeneesmiddelFilterForm
                portaalTeksten={portaalTeksten}
                geneesmiddelNaamFromFilter={geneesmiddelNaamFromFilter}
                onChangeFilter={this.handleOnChangeFilter}
                filterItems={filterItems}
                onSelectSearchOption={this.handleOnSelectSearchOption}
                onSearchTextChange={this.handleOnSearchTextChange}
                filterModel={filterModel}
                onSearch={this.handleOnSearch}
                onKeyUp={this.handleOnKeyUp}
                onChangeSelectOption={this.handleOnChangeSelectOption}
            />
            <GeneesmiddelOverzichtForm
                onPageNoChange={this.handleOnPageNoChange}
                onPageSizeChange={this.handleOnPageSizeChange}
                pagedGeneesmiddelen={pagedModels}
                onSortTable={this.handleOnSortTable}
                detailModalOpen={detailModalOpen}
                detailModel={detailModel}
                onClickShowDetail={this.handleOnClickShowDetail}
                onCancelShowDetail={this.handleOnCancelShowDetail}
            />
            </Section>);
    }
}

GeneesmiddelOverzichtPage.propTypes = {
    loadLayout: PropTypes.func
};

function mapStateToProps(state) {
    return {
        portaalTeksten: state.referentie.portaalTeksten
    };
}

function mapDispatchToProps(dispatch) {
    return {
        loadLayout: bindActionCreators(layoutActions.loadDefaultLayout, dispatch),
        ajaxActions: bindActionCreators(ajaxActions, dispatch),
        throwException: bindActionCreators(throwException, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(GeneesmiddelOverzichtPage);